module.exports = __webpack_public_path__ + "add-file.png?8780a849070d4f6a354fe2873c6d1bf2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/add-file.png
// module id = 928
// module chunks = 2